import type { MetaFunction } from "@remix-run/node";
import { Link } from "@remix-run/react";
import { SEOStructuredData } from "~/components/SEOStructuredData";

export const meta: MetaFunction = () => {
  return [
    { title: "女孩的秘密 - 专业的女性健康管理平台 | 月经周期管理 | 预产期计算" },
    { 
      name: "description", 
      content: "女孩的秘密是专业的女性健康管理平台，提供科学的月经周期管理、排卵期预测、安全期计算和预产期计算功能。帮助女性更好地了解自己的身体，科学管理健康生活。免费使用，隐私保护。" 
    },
    { 
      name: "keywords", 
      content: "女孩的秘密,月经周期管理,排卵期计算,安全期计算,预产期计算,女性健康,生理周期,月经追踪,孕期管理,女性生理健康" 
    },
    { name: "robots", content: "index, follow" },
    { name: "googlebot", content: "index, follow" },
    { name: "bingbot", content: "index, follow" },
    { name: "author", content: "Girls Secret Team" },
    { name: "language", content: "zh-CN" },
    { name: "geo.region", content: "CN" },
    { name: "geo.country", content: "China" },
    
    // Open Graph
    { property: "og:type", content: "website" },
    { property: "og:url", content: "https://girls-secret.com/" },
    { property: "og:title", content: "女孩的秘密 - 专业的女性健康管理平台" },
    { property: "og:description", content: "专业的女性健康管理平台，提供科学的月经周期管理、排卵期预测、安全期计算和预产期计算功能。" },
    { property: "og:image", content: "https://girls-secret.com/og-image-home.jpg" },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:locale", content: "zh_CN" },
    { property: "og:site_name", content: "女孩的秘密" },
    
    // Twitter
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: "女孩的秘密 - 专业的女性健康管理平台" },
    { name: "twitter:description", content: "专业的女性健康管理平台，提供科学的月经周期管理、排卵期预测、安全期计算和预产期计算功能。" },
    { name: "twitter:image", content: "https://girls-secret.com/og-image-home.jpg" },
    
    // 移动端优化
    { name: "mobile-web-app-capable", content: "yes" },
    { name: "apple-mobile-web-app-capable", content: "yes" },
    { name: "apple-mobile-web-app-title", content: "女孩的秘密" },
    { name: "format-detection", content: "telephone=no" },
  ];
};

export default function Index() {
  return (
    <div className="min-h-screen">
      <SEOStructuredData type="website" />
      {/* Header */}
      <header className="glass-card mx-4 mt-4 p-6">
        <div className="container mx-auto flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center">
              <span className="text-white font-bold text-lg">💕</span>
            </div>
            <h1 className="text-2xl font-bold gradient-text">女孩的秘密</h1>
          </div>
          <nav className="hidden md:flex space-x-6">
            <Link to="/" className="text-gray-600 hover:text-pink-600 transition-colors">
              首页
            </Link>
            <Link to="/cycle" className="text-gray-600 hover:text-pink-600 transition-colors">
              周期管理
            </Link>
            <Link to="/pregnancy" className="text-gray-600 hover:text-pink-600 transition-colors">
              预产期计算
            </Link>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold gradient-text mb-6 slide-in-right">
            专业的女性健康管理平台
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto slide-in-right">
            科学管理月经周期，精准预测排卵期和安全期，
            为您的健康生活提供专业指导
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center slide-in-right">
            <Link to="/cycle" className="btn-primary">
              开始周期管理
            </Link>
            <Link to="/pregnancy" className="btn-secondary">
              预产期计算
            </Link>
          </div>
        </div>

        {/* 主要功能模块 */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {/* 月经周期管理 - 包含排卵期、安全期 */}
          <Link to="/cycle" className="group">
            <div className="glass-card p-8 text-center hover:scale-105 transition-all duration-300 h-full">
              <div className="w-20 h-20 bg-gradient-to-r from-pink-400 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <span className="text-white text-3xl">📅</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">月经周期管理</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                一站式周期管理，包含月经期记录、排卵期预测、安全期计算等全面功能
              </p>
              <div className="grid grid-cols-1 gap-3 text-sm">
                <div className="flex items-center justify-center space-x-2 text-pink-600">
                  <span>📅</span>
                  <span>月经周期记录与预测</span>
                </div>
                <div className="flex items-center justify-center space-x-2 text-purple-600">
                  <span>🥚</span>
                  <span>排卵期精准计算</span>
                </div>
                <div className="flex items-center justify-center space-x-2 text-blue-600">
                  <span>🛡️</span>
                  <span>安全期科学分析</span>
                </div>
              </div>
            </div>
          </Link>

          {/* 预产期计算 */}
          <Link to="/pregnancy" className="group">
            <div className="glass-card p-8 text-center hover:scale-105 transition-all duration-300 h-full">
              <div className="w-20 h-20 bg-gradient-to-r from-green-400 to-emerald-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <span className="text-white text-3xl">👶</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">预产期计算</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                基于末次月经日期，科学计算预产期，提供完整的孕期信息和指导
              </p>
              <div className="grid grid-cols-1 gap-3 text-sm">
                <div className="flex items-center justify-center space-x-2 text-green-600">
                  <span>📊</span>
                  <span>孕期进度跟踪</span>
                </div>
                <div className="flex items-center justify-center space-x-2 text-emerald-600">
                  <span>📅</span>
                  <span>预产期精确计算</span>
                </div>
                <div className="flex items-center justify-center space-x-2 text-teal-600">
                  <span>🏥</span>
                  <span>孕期里程碑提醒</span>
                </div>
              </div>
            </div>
          </Link>
        </div>

        {/* 平台优势 */}
        <div className="glass-card p-8 mb-16">
          <h3 className="text-3xl font-bold text-center gradient-text mb-8">平台优势</h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-r from-pink-400 to-pink-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-3xl">🔬</span>
              </div>
              <h4 className="text-xl font-semibold text-gray-800 mb-2">科学精准</h4>
              <p className="text-gray-600">基于医学研究的科学算法，一次输入即可获得月经期、排卵期、安全期等全面信息</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-r from-purple-400 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-3xl">🔒</span>
              </div>
              <h4 className="text-xl font-semibold text-gray-800 mb-2">隐私安全</h4>
              <p className="text-gray-600">所有数据本地存储，无需注册登录，严格保护您的隐私和个人健康信息</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-3xl">⚡</span>
              </div>
              <h4 className="text-xl font-semibold text-gray-800 mb-2">简单高效</h4>
              <p className="text-gray-600">简化操作流程，两大核心功能模块，让女性健康管理变得更加轻松高效</p>
            </div>
          </div>
        </div>

        {/* 功能特色 */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="glass-card p-6">
            <h4 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <span className="text-2xl mr-3">📅</span>
              周期管理特色
            </h4>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-pink-500 rounded-full"></span>
                <span>一次输入，全面计算月经期、排卵期、安全期</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-purple-500 rounded-full"></span>
                <span>可视化周期图表，直观了解当前状态</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                <span>智能提醒和健康建议</span>
              </li>
            </ul>
          </div>
          <div className="glass-card p-6">
            <h4 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <span className="text-2xl mr-3">👶</span>
              孕期计算特色
            </h4>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                <span>精确预产期计算和孕期进度跟踪</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-emerald-500 rounded-full"></span>
                <span>详细的孕期里程碑和注意事项</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-teal-500 rounded-full"></span>
                <span>孕早期、中期、晚期分阶段指导</span>
              </li>
            </ul>
          </div>
        </div>

        {/* 免责声明 */}
        <div className="glass-card p-6 text-center">
          <h4 className="text-lg font-semibold text-gray-800 mb-2">医疗免责声明</h4>
          <p className="text-gray-600 text-sm leading-relaxed">
            本平台提供的计算结果仅供参考，不能替代专业医疗建议。
            如有健康问题，请咨询专业医生。个体差异可能影响计算准确性，
            请结合自身情况合理使用本工具。
          </p>
        </div>
      </section>
    </div>
  );
}